import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-festive-part',
  templateUrl: './festive-part.component.html',
  styleUrls: ['./festive-part.component.css']
})
export class FestivePartComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
